
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
import DropdownOption from "@/entities/DropdownOption";
import InputPlaceholder from "@/components/skeletonPlaceholder/components/InputPlaceholder.vue";
import GetTypeOfVisits from "@/apollo/projectActivities/GetTypeOfVisits.gql";

@Component({
  components: {
    InputPlaceholder,
    DropdownFilter,
  },
  apollo: {
    visitType: {
      query: GetTypeOfVisits,
      update(data) {
        this.isDataLoaded = true;
        const visitTypes = data.__type.enumValues.map((item) => ({
          id: item.name, // Keep the raw enum name as ID
          name: item.name
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()), // Convert to readable format
        }));
        this.visitType = visitTypes;
        return visitTypes;
      },
    },
  },
})
export default class TypeOfVisitMultiselect extends Vue {

  @Prop({ type: String, default: "" }) selectedTypeOfVisitId!: string;
  @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
   @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;

  selectedTypeOfVisit: DropdownOption[] = [];
  visitType: DropdownOption[] = [];
  isDataLoaded = false;

  get visitTypeLoaded(): boolean {
   return this.isDataLoaded;
  }

@Watch("selectedTypeOfVisitId", { immediate: true })
  @Watch("visitType", { immediate: true, deep: true })
  onDataChanged(): void {
    // Ensure visit types are loaded and a selected ID exists
    if (this.isDataLoaded && this.selectedTypeOfVisitId) {
        const selectedType = this.visitType.filter((visit) =>
        this.selectedTypeOfVisitId.includes(visit.id)
      );
      this.selectedTypeOfVisit = selectedType.map((tag) => ({
        name: tag.name,
        id: tag.id,
      }));
    }
  }

  handleSelection(selectedVisit: { id: string; name: string }[]): void {
    this.selectedTypeOfVisit = selectedVisit || null;
    this.$emit("input", selectedVisit); 
  }
}
